import React, { useEffect, useState } from 'react'
import { useApolloClient } from 'react-apollo'

import { SessionAutoRefresh } from 'components/SessionAutoRefresh'
import { SessionInactivityDetection } from 'components/SessionInactivityDetection'
import { closeSession, isAuthenticated, refreshSessionCookies } from 'utils/auth'
import { EnvironmentProps, withEnv } from 'utils/environment'
import { getWindow } from '@acorns/web-utils'
import { USER_UUID } from 'app-constants'

export const SessionProvider = withEnv(
  ({ env, children }: { children: React.ReactNode } & EnvironmentProps) => {
    const apolloClient = useApolloClient()

    const [sessionRefreshOnAppLoadCompleted, setSessionRefreshOnAppLoadCompleted] = useState(false)

    useEffect(
      function refreshSessionOnAppLoad() {
        if (!apolloClient) {
          return
        }

        if (isAuthenticated()) {
          refreshSessionCookies(apolloClient).then(() => {
            setSessionRefreshOnAppLoadCompleted(true)
          })
        } else {
          setSessionRefreshOnAppLoadCompleted(true)
        }
      },
      [apolloClient],
    )

    useEffect(
      function checkAuthStatusOnPageVisibilityChange() {
        if (!apolloClient || !env) {
          return
        }

        window.document.addEventListener('visibilitychange', () => {
          if (
            window.document.visibilityState === 'visible' &&
            isAuthenticated() === false &&
            window.sessionStorage.getItem(USER_UUID) // USER_UUID in session storage indicates a previous auth session
          ) {
            closeSession(apolloClient).then(() => {
              getWindow().location.replace(env.get('loginUrl'))
            })
          }
        })
      },
      [apolloClient, env],
    )

    if (sessionRefreshOnAppLoadCompleted) {
      return (
        <>
          <SessionAutoRefresh />
          <SessionInactivityDetection />
          {children}
        </>
      )
    }

    return null
  },
)
